// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bZTLpx {
  margin: 0;
  height: 100vh;
  padding: 0 !important;
  position: fixed !important;
  right: 0;
  top: 0;
}

.NIxWY4 {
  margin: 0 auto;
  max-width: var(--grid-breakpoint-l);
  height: 100vh;
  transform: none !important;
}

.m0F2F_ {
  margin: 0;
  margin-left: auto;
  max-width: 400px;
  height: 100vh;
  border-radius: 0;
  border: none;
  background-color: var(--surface-neutral-white);
  display: flex;
  flex-direction: column;
}

.BlJzAE {
  padding: var(--spacing-3) var(--spacing-2) 0;
  border: none;
  display: flex;
  align-items: center;
  gap: var(--spacing-1);
  flex-shrink: 0;
}

.RbmYv5 {
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
}

.RbmYv5 img {
  width: 100%;
  height: 100%;
}

.spUzYz {
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-semibold);
  font-size: var(--font-size-xl);
  line-height: var(--line-height-160);
  color: var(--text-neutral-dark);
  margin: 0;
  flex: 1;
}

.HgXHlv {
  padding: var(--spacing-3) 0 0 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  flex: 1;
}

.YrzP9p {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  min-height: 400px;
  gap: var(--spacing-2);
  padding: var(--spacing-2);
}

.XCZWRi,
.zARhu5 {
  background: rgba(214, 64, 0, 0.1);
  border-radius: 50%;
  display: flex;
  height: 72px;
  width: 72px;
  align-items: center;
  justify-content: center;
}

.bjllET {
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-semibold);
  font-size: var(--font-size-lg);
  line-height: var(--line-height-180);
  color: var(--text-neutral-dark);
  margin-bottom: 0;
  margin-top: 0;
}

.gbEgIY {
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-md);
  line-height: var(--line-height-180);
  color: var(--text-neutral-dark);
  margin-bottom: 0;
  text-align: center;
}

.VfNUWZ {
  margin: var(--spacing-1);
}

.C7rNUV {
  padding: 0 var(--spacing-3);
  display: flex;
  flex-direction: column;
  gap: var(--spacing-3);
  overflow-y: auto;
  flex: 1;
}

.uSKQUL {
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-md);
  line-height: var(--line-height-180);
  color: var(--text-neutral-dark);
  margin: 0;
}

.IczUqT {
  display: flex;
  align-items: flex-start;
  gap: var(--spacing-2);
  padding: var(--spacing-1) var(--spacing-1-5);
  background-color: #fee7e7;
  border: 1px solid var(--status-error);
  border-radius: 8px;
}

.leX8qY {
  height: 20px;
  width: 20px;
  flex-shrink: 0;
  margin-top: var(--spacing-0-5);
}

.rQ6b7N,
.AdapWv {
  height: 32px;
  width: 32px;
}

.taEUsw {
  flex: 1;
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-md);
  line-height: var(--line-height-160);
  color: var(--text-neutral-dark);
}

.gcpCUd {
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  margin-top: var(--spacing-0-5);
}

.BruuV_ {
  width: 16px;
  height: 16px;
  color: var(--text-neutral-medium);
}

.mh5r0G {
  background: #fafafa;
  border-radius: 4px;
  padding: var(--spacing-3);
  display: flex;
  flex-direction: column;
  gap: var(--spacing-2);
}

.OW0Lf7 {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: var(--spacing-3);
}

.GIgJ4f {
  width: var(--spacing-4);
  height: var(--spacing-4);
  background: var(--surface-primary-medium);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

._9Sthmq {
  width: var(--spacing-2);
  height: var(--spacing-2);
  filter: brightness(0) invert(1);
}

.ikBx7h {
  background: none;
  border: none;
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-semibold);
  font-size: var(--font-size-sm);
  color: var(--text-primary-medium);
  display: inline-flex;
  align-items: center;
  gap: var(--spacing-1);
  cursor: pointer;
  padding: 0;
  text-decoration: none;
  transition: color 0.2s ease;
}

.ikBx7h:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.ikBx7h:hover:not(:disabled) {
  text-decoration: underline;
}

.JlYQ4V {
  width: 12px;
  height: 12px;
  margin-left: var(--spacing-1);
  flex-shrink: 0;
  filter: brightness(0) saturate(100%) invert(27%) sepia(98%) saturate(2742%) hue-rotate(360deg) brightness(96%)
    contrast(103%);
  transition: filter 0.2s ease;
}

.cmPe2m {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-2);
}

.uffR3c {
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-semibold);
  font-size: var(--font-size-lg);
  line-height: var(--line-height-160);
  color: var(--text-neutral-dark);
  margin: 0;
}

.sqvQ5E {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: var(--spacing-0-5);
}

.Nsiz0I {
  display: flex;
  align-items: center;
  gap: var(--spacing-1-5);
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-md);
  line-height: var(--line-height-180);
  color: var(--text-neutral-dark);
}

.xQWbzH {
  width: 20px;
  height: 20px;
  flex-shrink: 0;
  background-color: var(--text-neutral-dark);
  -webkit-mask-repeat: no-repeat;
  mask-repeat: no-repeat;
  -webkit-mask-position: center;
  mask-position: center;
  -webkit-mask-size: contain;
  mask-size: contain;
}

.S3VENA {
  width: 20px;
  height: 20px;
  flex-shrink: 0;
}

.QZLizu {
  flex: 1;
}

.ck4ti9 {
  border-top: 1px solid var(--stroke-neutral-subtle);
  padding-top: var(--spacing-2);
  display: flex;
  align-items: center;
  gap: var(--spacing-2);
}

.X2AXdP {
  display: flex;
  align-items: center;
  gap: var(--spacing-2);
  font-family: var(--font-family-base);
  font-size: var(--font-size-sm);
  line-height: var(--line-height-160);
  width: 100%;
}

.ZKzg3_ {
  display: flex;
  flex: 1;
  gap: var(--spacing-2);
}

.jouBBn {
  display: flex;
  align-items: center;
  gap: var(--spacing-1);
}

.elpHqv {
  width: 16px;
  height: 16px;
  flex-shrink: 0;
}

.su4wRv {
  width: var(--spacing-1);
  height: var(--spacing-1);
  background-color: var(--text-helper);
  border-radius: 50%;
  margin: 0 var(--spacing-0-5);
}

.MzoA9p {
  color: var(--text-neutral-dark);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-sm);
  line-height: var(--line-height-160);
}

._fPcxv {
  color: var(--status-success);
}

@media (max-width: 768px) {
  .NIxWY4 {
    width: 95%;
    margin: 1rem auto;
  }

  .BlJzAE {
    padding: 0.75rem 1rem;
  }
}
`, "",{"version":3,"sources":["webpack://./../../packages/beneficios/src/pages/EmissorContractedBenefitsModal/EmissorContractedBenefitsModal.module.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,aAAa;EACb,qBAAqB;EACrB,0BAA0B;EAC1B,QAAQ;EACR,MAAM;AACR;;AAEA;EACE,cAAc;EACd,mCAAmC;EACnC,aAAa;EACb,0BAA0B;AAC5B;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,8CAA8C;EAC9C,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,4CAA4C;EAC5C,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,oCAAoC;EACpC,wCAAwC;EACxC,8BAA8B;EAC9B,mCAAmC;EACnC,+BAA+B;EAC/B,SAAS;EACT,OAAO;AACT;;AAEA;EACE,+BAA+B;EAC/B,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,OAAO;AACT;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,iBAAiB;EACjB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;;EAEE,iCAAiC;EACjC,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,wCAAwC;EACxC,8BAA8B;EAC9B,mCAAmC;EACnC,+BAA+B;EAC/B,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,oCAAoC;EACpC,uCAAuC;EACvC,8BAA8B;EAC9B,mCAAmC;EACnC,+BAA+B;EAC/B,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,2BAA2B;EAC3B,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,gBAAgB;EAChB,OAAO;AACT;;AAEA;EACE,oCAAoC;EACpC,uCAAuC;EACvC,8BAA8B;EAC9B,mCAAmC;EACnC,+BAA+B;EAC/B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,qBAAqB;EACrB,4CAA4C;EAC5C,yBAAyB;EACzB,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,cAAc;EACd,8BAA8B;AAChC;;AAEA;;EAEE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,OAAO;EACP,oCAAoC;EACpC,uCAAuC;EACvC,8BAA8B;EAC9B,mCAAmC;EACnC,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;EACvB,wBAAwB;EACxB,yCAAyC;EACzC,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,wBAAwB;EACxB,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,oCAAoC;EACpC,wCAAwC;EACxC,8BAA8B;EAC9B,iCAAiC;EACjC,oBAAoB;EACpB,mBAAmB;EACnB,qBAAqB;EACrB,eAAe;EACf,UAAU;EACV,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,cAAc;EACd;kBACgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,oCAAoC;EACpC,wCAAwC;EACxC,8BAA8B;EAC9B,mCAAmC;EACnC,+BAA+B;EAC/B,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oCAAoC;EACpC,uCAAuC;EACvC,8BAA8B;EAC9B,mCAAmC;EACnC,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,0CAA0C;EAC1C,8BAA8B;EAC9B,sBAAsB;EACtB,6BAA6B;EAC7B,qBAAqB;EACrB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,kDAAkD;EAClD,6BAA6B;EAC7B,aAAa;EACb,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,oCAAoC;EACpC,8BAA8B;EAC9B,mCAAmC;EACnC,WAAW;AACb;;AAEA;EACE,aAAa;EACb,OAAO;EACP,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,wBAAwB;EACxB,oCAAoC;EACpC,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,+BAA+B;EAC/B,uCAAuC;EACvC,8BAA8B;EAC9B,mCAAmC;AACrC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE;IACE,UAAU;IACV,iBAAiB;EACnB;;EAEA;IACE,qBAAqB;EACvB;AACF","sourcesContent":[".modal {\n  margin: 0;\n  height: 100vh;\n  padding: 0 !important;\n  position: fixed !important;\n  right: 0;\n  top: 0;\n}\n\n.modalDialog {\n  margin: 0 auto;\n  max-width: var(--grid-breakpoint-l);\n  height: 100vh;\n  transform: none !important;\n}\n\n.modalContent {\n  margin: 0;\n  margin-left: auto;\n  max-width: 400px;\n  height: 100vh;\n  border-radius: 0;\n  border: none;\n  background-color: var(--surface-neutral-white);\n  display: flex;\n  flex-direction: column;\n}\n\n.modalHeader {\n  padding: var(--spacing-3) var(--spacing-2) 0;\n  border: none;\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-1);\n  flex-shrink: 0;\n}\n\n.backButton {\n  background: none;\n  border: none;\n  padding: 0;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 24px;\n  height: 24px;\n}\n\n.backButton img {\n  width: 100%;\n  height: 100%;\n}\n\n.modalTitle {\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-semibold);\n  font-size: var(--font-size-xl);\n  line-height: var(--line-height-160);\n  color: var(--text-neutral-dark);\n  margin: 0;\n  flex: 1;\n}\n\n.modalBody {\n  padding: var(--spacing-3) 0 0 0;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  flex: 1;\n}\n\n.feedbackContainer {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n  min-height: 400px;\n  gap: var(--spacing-2);\n  padding: var(--spacing-2);\n}\n\n.feedbackIconContent,\n.loadingIconContent {\n  background: rgba(214, 64, 0, 0.1);\n  border-radius: 50%;\n  display: flex;\n  height: 72px;\n  width: 72px;\n  align-items: center;\n  justify-content: center;\n}\n\n.feedbackTitle {\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-semibold);\n  font-size: var(--font-size-lg);\n  line-height: var(--line-height-180);\n  color: var(--text-neutral-dark);\n  margin-bottom: 0;\n  margin-top: 0;\n}\n\n.feedbackText {\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-regular);\n  font-size: var(--font-size-md);\n  line-height: var(--line-height-180);\n  color: var(--text-neutral-dark);\n  margin-bottom: 0;\n  text-align: center;\n}\n\n.feedbackButton {\n  margin: var(--spacing-1);\n}\n\n.layoutWrapper {\n  padding: 0 var(--spacing-3);\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-3);\n  overflow-y: auto;\n  flex: 1;\n}\n\n.introText {\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-regular);\n  font-size: var(--font-size-md);\n  line-height: var(--line-height-180);\n  color: var(--text-neutral-dark);\n  margin: 0;\n}\n\n.errorAlert {\n  display: flex;\n  align-items: flex-start;\n  gap: var(--spacing-2);\n  padding: var(--spacing-1) var(--spacing-1-5);\n  background-color: #fee7e7;\n  border: 1px solid var(--status-error);\n  border-radius: 8px;\n}\n\n.errorIcon {\n  height: 20px;\n  width: 20px;\n  flex-shrink: 0;\n  margin-top: var(--spacing-0-5);\n}\n\n.feedbackIcon,\n.emptyIcon {\n  height: 32px;\n  width: 32px;\n}\n\n.errorText {\n  flex: 1;\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-regular);\n  font-size: var(--font-size-md);\n  line-height: var(--line-height-160);\n  color: var(--text-neutral-dark);\n}\n\n.errorClose {\n  background: none;\n  border: none;\n  padding: 0;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  margin-top: var(--spacing-0-5);\n}\n\n.errorCloseIcon {\n  width: 16px;\n  height: 16px;\n  color: var(--text-neutral-medium);\n}\n\n.contractCard {\n  background: #fafafa;\n  border-radius: 4px;\n  padding: var(--spacing-3);\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-2);\n}\n\n.cardHeader {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: var(--spacing-3);\n}\n\n.cardIconWrapper {\n  width: var(--spacing-4);\n  height: var(--spacing-4);\n  background: var(--surface-primary-medium);\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.cardMainIcon {\n  width: var(--spacing-2);\n  height: var(--spacing-2);\n  filter: brightness(0) invert(1);\n}\n\n.pdfLink {\n  background: none;\n  border: none;\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-semibold);\n  font-size: var(--font-size-sm);\n  color: var(--text-primary-medium);\n  display: inline-flex;\n  align-items: center;\n  gap: var(--spacing-1);\n  cursor: pointer;\n  padding: 0;\n  text-decoration: none;\n  transition: color 0.2s ease;\n}\n\n.pdfLink:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.pdfLink:hover:not(:disabled) {\n  text-decoration: underline;\n}\n\n.pdfLinkIcon {\n  width: 12px;\n  height: 12px;\n  margin-left: var(--spacing-1);\n  flex-shrink: 0;\n  filter: brightness(0) saturate(100%) invert(27%) sepia(98%) saturate(2742%) hue-rotate(360deg) brightness(96%)\n    contrast(103%);\n  transition: filter 0.2s ease;\n}\n\n.cardBody {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-2);\n}\n\n.contractTitle {\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-semibold);\n  font-size: var(--font-size-lg);\n  line-height: var(--line-height-160);\n  color: var(--text-neutral-dark);\n  margin: 0;\n}\n\n.productList {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-0-5);\n}\n\n.productItem {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-1-5);\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-regular);\n  font-size: var(--font-size-md);\n  line-height: var(--line-height-180);\n  color: var(--text-neutral-dark);\n}\n\n.productIcon {\n  width: 20px;\n  height: 20px;\n  flex-shrink: 0;\n  background-color: var(--text-neutral-dark);\n  -webkit-mask-repeat: no-repeat;\n  mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  mask-position: center;\n  -webkit-mask-size: contain;\n  mask-size: contain;\n}\n\n.productIconFallback {\n  width: 20px;\n  height: 20px;\n  flex-shrink: 0;\n}\n\n.productLabel {\n  flex: 1;\n}\n\n.cardFooter {\n  border-top: 1px solid var(--stroke-neutral-subtle);\n  padding-top: var(--spacing-2);\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-2);\n}\n\n.statusLine {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-2);\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-sm);\n  line-height: var(--line-height-160);\n  width: 100%;\n}\n\n.statusLineContent {\n  display: flex;\n  flex: 1;\n  gap: var(--spacing-2);\n}\n\n.status {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-1);\n}\n\n.statusIcon {\n  width: 16px;\n  height: 16px;\n  flex-shrink: 0;\n}\n\n.statusIconProcessing {\n  width: var(--spacing-1);\n  height: var(--spacing-1);\n  background-color: var(--text-helper);\n  border-radius: 50%;\n  margin: 0 var(--spacing-0-5);\n}\n\n.statusText {\n  color: var(--text-neutral-dark);\n  font-weight: var(--font-weight-regular);\n  font-size: var(--font-size-sm);\n  line-height: var(--line-height-160);\n}\n\n.statusActiveText {\n  color: var(--status-success);\n}\n\n@media (max-width: 768px) {\n  .modalDialog {\n    width: 95%;\n    margin: 1rem auto;\n  }\n\n  .modalHeader {\n    padding: 0.75rem 1rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal": `bZTLpx`,
	"modalDialog": `NIxWY4`,
	"modalContent": `m0F2F_`,
	"modalHeader": `BlJzAE`,
	"backButton": `RbmYv5`,
	"modalTitle": `spUzYz`,
	"modalBody": `HgXHlv`,
	"feedbackContainer": `YrzP9p`,
	"feedbackIconContent": `XCZWRi`,
	"loadingIconContent": `zARhu5`,
	"feedbackTitle": `bjllET`,
	"feedbackText": `gbEgIY`,
	"feedbackButton": `VfNUWZ`,
	"layoutWrapper": `C7rNUV`,
	"introText": `uSKQUL`,
	"errorAlert": `IczUqT`,
	"errorIcon": `leX8qY`,
	"feedbackIcon": `rQ6b7N`,
	"emptyIcon": `AdapWv`,
	"errorText": `taEUsw`,
	"errorClose": `gcpCUd`,
	"errorCloseIcon": `BruuV_`,
	"contractCard": `mh5r0G`,
	"cardHeader": `OW0Lf7`,
	"cardIconWrapper": `GIgJ4f`,
	"cardMainIcon": `_9Sthmq`,
	"pdfLink": `ikBx7h`,
	"pdfLinkIcon": `JlYQ4V`,
	"cardBody": `cmPe2m`,
	"contractTitle": `uffR3c`,
	"productList": `sqvQ5E`,
	"productItem": `Nsiz0I`,
	"productIcon": `xQWbzH`,
	"productIconFallback": `S3VENA`,
	"productLabel": `QZLizu`,
	"cardFooter": `ck4ti9`,
	"statusLine": `X2AXdP`,
	"statusLineContent": `ZKzg3_`,
	"status": `jouBBn`,
	"statusIcon": `elpHqv`,
	"statusIconProcessing": `su4wRv`,
	"statusText": `MzoA9p`,
	"statusActiveText": `_fPcxv`
};
module.exports = ___CSS_LOADER_EXPORT___;
